import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { EntityKpi } from '@components/EntityKpi'
import { MyListButton } from '@components/MyListButton'
import { formatDateTime } from '@util/date-util'

import type { Activiteit } from '../../../entity/activiteiten/types/Activiteit'
import { Due } from '../../../theme/components/Due'
import { Label } from '../../../theme/components/Label'
import { MultilineTypography } from '../../../theme/components/MultilineTypography'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

interface Props {
  activiteit: Activiteit
}

export const ActiviteitenTableRow = ({ activiteit }: Props) => {
  const {
    _id,
    type,
    text,
    changed,
    assignedTo,
    dueDate,
    entity: { id: entityId, type: entityType, gebiedscodeLabel },
    searchValues,
    myList,
    labels,
    kpi,
  } = activiteit
  const { organisatie, date: created } = activiteit.created

  return (
    <TableRow key={_id}>
      <TableCell>
        <EntityKpi kpi={kpi} />
      </TableCell>
      <TableCell>{type}</TableCell>
      <TableCell>
        <MultilineTypography text={text} />
      </TableCell>
      <TableCell>
        <Due dueDate={dueDate as string | undefined} />
      </TableCell>
      <TableCell>{formatDateTime(created)}</TableCell>
      <TableCell>{organisatie}</TableCell>
      <TableCell>{assignedTo && assignedTo.join(', ')}</TableCell>
      <TableCell>{formatDateTime(changed)}</TableCell>
      <TableCell>
        {searchValues?.naam}
        <br />
        <Typography variant="caption">
          <span>#</span>
          {entityId}
        </Typography>
      </TableCell>
      <TableCell>{searchValues?.gemeente}</TableCell>
      <TableCell>
        {gebiedscodeLabel}
        <br />
        {labels && labels.map((l) => <Label text={l} key={l} small={true} />)}
      </TableCell>
      <TableCell>
        <MyListButton
          type="hoofdleiding"
          disabled={true}
          active={myList}
          aanvraagID={''}
        />

        <StyledIconLink
          icon={<LaunchIcon />}
          title={`Navigeer naar ${entityType} ${entityId}`}
          href={`/hoofdleiding/${entityType}/${entityId}`}
        />
      </TableCell>
    </TableRow>
  )
}
